import { render, staticRenderFns } from "./QueryAuditTrailView.vue?vue&type=template&id=efaa323c&scoped=true"
import script from "./QueryAuditTrailView.vue?vue&type=script&lang=ts"
export * from "./QueryAuditTrailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaa323c",
  null
  
)

export default component.exports